import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import { TreeCategory } from '@p1/libs/catalog-service';

import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'p1-category-tile',
  templateUrl: './category-tile.component.html',
  styleUrls: ['./category-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CategoryTileComponent implements OnChanges {

  @Input()
  name: string;

  @Input()
  pathedSlugs: string;

  @Input()
  advertising: boolean = false;

  @Input()
  imageUuid: string;

  @Input()
  childCategories: TreeCategory[];

  subCategoriesPreviewFold: number = 5;
  subCategoriesPreviewFoldTolerance: number = 1;
  featureFlags = environment.featureFlags;

  private _initalSubCategoriesPreviewFold = 5;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['childCategories']) {
      if (this.childCategories && this.childCategories.length - this.subCategoriesPreviewFold <= this.subCategoriesPreviewFoldTolerance) {
        this.subCategoriesPreviewFold = this.subCategoriesPreviewFoldTolerance + this._initalSubCategoriesPreviewFold;
      } else {
        this.subCategoriesPreviewFold = this._initalSubCategoriesPreviewFold;
      }
    }
  }
}
